import { NgModule  } from '@angular/core';

import { BookingRequestActionsComponent } from './booking.request.actions.component';
import { BookingsApiKeyComponent }        from './bookings.api-key.component';
import { BookingsApiSecretKeyComponent }  from './bookings.api-secret-key.component';
import { SharedModule }                   from '../../app-lite/shared/shared.module';

@NgModule({
  declarations: [
    BookingRequestActionsComponent,
    BookingsApiKeyComponent,
    BookingsApiSecretKeyComponent
  ],
  entryComponents: [
    BookingRequestActionsComponent,
    BookingsApiKeyComponent,
    BookingsApiSecretKeyComponent
  ],
  exports: [
    BookingsApiKeyComponent
  ],
  imports: [
    SharedModule
  ]
})
export class BookingsModule {}